import { render } from "./priority.vue?vue&type=template&id=2e108390&scoped=true"
import script from "./priority.vue?vue&type=script&lang=js"
export * from "./priority.vue?vue&type=script&lang=js"

import "./priority.vue?vue&type=style&index=0&id=2e108390&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e108390"]])

export default __exports__